import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { contentHeaders,APIURL,JsonURL } from '../common/headers';
import { IUsers } from '../database';
@Injectable()
export class ChapterService {

    private _getChapterUrl = APIURL+'Chapter/chapters';
    private _getAllChapterUrl = APIURL+'Chapter/getAllChapters';
    private _isActivelUrl = APIURL+'Chapter/ChapterVerify';
    private _deleteUrl = APIURL+'Chapter/deleteChapter';
    private _addUrl = APIURL+'Chapter/saveChapter';
    private _chapterByProductUrl = APIURL+'Chapter/ChapterByProduct';
    private _getChapterAllTextUrl = APIURL+'Chapter/ChapterByText';
    private _editUrl = APIURL+'Chapter/updateChapterById';
     private _getChapterByIdUrl = APIURL+'Chapter/getChapterById';
   
    private currentUser :IUsers ; 
    constructor(private _http: Http) { 
           
   
    }
    ischapterActive(ChapterId:string,type): any{
        this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
         let formData:FormData = new FormData();
         formData.append('ChapterId', ChapterId);
          formData.append('type', type);
        return this._http.post(this._isActivelUrl,formData )
                            .map((response: Response) => response.json())
                            .catch(this.handleError);
    }
     add(form:any):any{
        this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
          let formData:FormData = new FormData();
         formData.append('ChapterName', form.ChapterName);
         formData.append('ProductId', form.ProductId);
         formData.append('userId', this.currentUser.UserId+"");
      return this._http.post(this._addUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
     edit(form:any):any{
        this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
          let formData:FormData = new FormData();
         formData.append('ChapterName', form.ChapterName);
         formData.append('ProductId', form.ProductId);
         formData.append('ChapterID', form.ChapterID);
      return this._http.post(this._editUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getChapterByTextAndSize(search,pageNo,pageSize){
        this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
         let formData:FormData = new FormData();
         formData.append('UserId', this.currentUser.UserId+"");
         formData.append('search', search);
         formData.append('pageSize', pageSize);
         formData.append('pageNo', pageNo);
           
        return this._http.post(this._getChapterAllTextUrl,formData )
                            .map((response: Response) => response.json().data)

    }
    getChapterAllByTextAndSize(search,pageNo,pageSize){
        this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
         let formData:FormData = new FormData();
          formData.append('search', search);
          formData.append('pageSize', pageSize);
          formData.append('pageNo', pageNo);
        return this._http.post(this._getChapterAllTextUrl,formData )
                            .map((response: Response) => response.json().data)

    }
    getAllChapters(): any{
        this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
        return this._http.post(this._getAllChapterUrl,[] )
                            .map((response: Response) => response.json().data)
         
    }
     getChapterById(ChapterId): any{
        this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
         let formData:FormData = new FormData();
         formData.append('ChapterId', ChapterId);
        return this._http.post(this._getChapterByIdUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
    getChapters(UserId): any{
        this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
        let formData:FormData = new FormData();
         formData.append('UserId', UserId);
        return this._http.post(this._getChapterUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
    delete(ChapterId): any{
        this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
           let formData:FormData = new FormData();
         formData.append('ChapterId', ChapterId);
        return this._http.post(this._deleteUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
    getChaptersBYProdectId(ProdectId){
        this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
         let formData:FormData = new FormData();
         formData.append('ProdectId', ProdectId);
        return this._http.post(this._chapterByProductUrl,formData )
                            .map((response: Response) => response.json().data)
    }
     private handleError(error: Response) {
        
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./src/app/service/chapter.service.ts